<div class="modal-header">
    <h4 class="modal-title">Filter {{Title}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12" *ngIf="ShowFilter.ShowBranch">
            <label for="BranchID" class="form-font-label">Branch<span class="text-danger">*</span></label>
            <ng-select name="BranchID" (change)="ApprovalComboLoad('Client')" [(ngModel)]="Filter.BranchID"
                #BranchID="ngModel" required>
                <ng-option [value]=0>All</ng-option>
                <ng-option *ngFor="let Branch of Branchs"
                    [value]="Branch.BranchMasterID">{{Branch.BranchName}}</ng-option>
            </ng-select>
            <div class="invalid-feedback">
                Please select branch!
            </div>
        </div>

        <div class="col-md-12" *ngIf="ShowFilter.ShowClient">
            <label for="ClientID" class="form-font-label">Client<span class="text-danger">*</span></label>
            <ng-select name="ClientID" (change)="ApprovalComboLoad('Site')" [(ngModel)]="Filter.ClientID"
                #ClientID="ngModel" required>
                <ng-option [value]=0>All</ng-option>
                <ng-option *ngFor="let Client of Clients"
                    [value]="Client.ClientGroupMasterID">{{Client.ClientGroupName}}</ng-option>
            </ng-select>
            <div class="invalid-feedback">
                Please select client!
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">

    <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled" (click)="close()"><i
            class="bi bi-funnel" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Filter':'Loading...'}}</button>

    <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="isDisabled" (click)="close()"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Close':'Loading...'}}</button>

</div>